/** Find out where this browser stands with push notifications (pushStatus). */
export const CHECK_PUSH = 'PUSH/CHECK_PUSH';
export const TURN_ON_PUSH = 'PUSH/TURN_ON_PUSH';
export const TURN_OFF_PUSH = 'PUSH/TURN_OFF_PUSH';
export const SET_PUSH_STATUS = 'PUSH/SET_PUSH_STATUS';

/** The service worker that shows the notifications (public/push-worker.js). */
export const PUSH_WORKER_URL = '/push-worker.js';
